import axios from 'axios';

const apiClient = axios.create({
	baseURL: `${process.env.VUE_APP_API_URL}/wp-json/wp/v2`,
	timeout: 10000,
});

const getFirstItem = (data) => (Array.isArray(data) ? data[0] ?? null : null);

const request = async (url) => {
	try {
		const response = await apiClient.get(url);
		return response.data;
	} catch (error) {
		console.error(`WordPress API request failed for ${url}`, error);
		return null;
	}
};

export const getPosts = async () => {
	return request('/posts?_embed');
};

export const getPage = async (id) => {
	return request(`/pages/${id}?acf_format=standard&_embed`);
};

export const getPageBySlug = async (slug) => {
	const data = await request(`/pages?slug=${encodeURIComponent(slug)}&acf_format=standard&_embed`);
	return getFirstItem(data);
};

export const getPostBySlug = async (slug) => {
	const data = await request(`/posts?slug=${encodeURIComponent(slug)}&acf_format=standard&_embed`);
	return getFirstItem(data);
};
